import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\PlaygroundController::send
* @see app/Http/Controllers/Admin/PlaygroundController.php:57
* @route '/app/agents/{agent}/playground'
*/
export const send = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

send.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/playground',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::send
* @see app/Http/Controllers/Admin/PlaygroundController.php:57
* @route '/app/agents/{agent}/playground'
*/
send.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return send.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::send
* @see app/Http/Controllers/Admin/PlaygroundController.php:57
* @route '/app/agents/{agent}/playground'
*/
send.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::send
* @see app/Http/Controllers/Admin/PlaygroundController.php:57
* @route '/app/agents/{agent}/playground'
*/
const sendForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::send
* @see app/Http/Controllers/Admin/PlaygroundController.php:57
* @route '/app/agents/{agent}/playground'
*/
sendForm.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(args, options),
    method: 'post',
})

send.form = sendForm

/**
* @see \App\Http\Controllers\Admin\PlaygroundStreamController::__invoke
* @see app/Http/Controllers/Admin/PlaygroundStreamController.php:60
* @route '/app/agents/{agent}/playground/stream'
*/
export const stream = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stream.url(args, options),
    method: 'post',
})

stream.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/playground/stream',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PlaygroundStreamController::__invoke
* @see app/Http/Controllers/Admin/PlaygroundStreamController.php:60
* @route '/app/agents/{agent}/playground/stream'
*/
stream.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return stream.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PlaygroundStreamController::__invoke
* @see app/Http/Controllers/Admin/PlaygroundStreamController.php:60
* @route '/app/agents/{agent}/playground/stream'
*/
stream.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stream.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundStreamController::__invoke
* @see app/Http/Controllers/Admin/PlaygroundStreamController.php:60
* @route '/app/agents/{agent}/playground/stream'
*/
const streamForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: stream.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundStreamController::__invoke
* @see app/Http/Controllers/Admin/PlaygroundStreamController.php:60
* @route '/app/agents/{agent}/playground/stream'
*/
streamForm.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: stream.url(args, options),
    method: 'post',
})

stream.form = streamForm

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::reset
* @see app/Http/Controllers/Admin/PlaygroundController.php:101
* @route '/app/agents/{agent}/playground/reset'
*/
export const reset = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(args, options),
    method: 'post',
})

reset.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/playground/reset',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::reset
* @see app/Http/Controllers/Admin/PlaygroundController.php:101
* @route '/app/agents/{agent}/playground/reset'
*/
reset.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return reset.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::reset
* @see app/Http/Controllers/Admin/PlaygroundController.php:101
* @route '/app/agents/{agent}/playground/reset'
*/
reset.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::reset
* @see app/Http/Controllers/Admin/PlaygroundController.php:101
* @route '/app/agents/{agent}/playground/reset'
*/
const resetForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PlaygroundController::reset
* @see app/Http/Controllers/Admin/PlaygroundController.php:101
* @route '/app/agents/{agent}/playground/reset'
*/
resetForm.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(args, options),
    method: 'post',
})

reset.form = resetForm

const playground = {
    send: Object.assign(send, send),
    stream: Object.assign(stream, stream),
    reset: Object.assign(reset, reset),
}

export default playground